export const CONTACT_SUPPORT_URL = 'https://support.paziresh24.com/';
export const CONTACT_FAQ_URL = '/faq/';

export const contactPageTitle = 'تماس با ما';

export const contactIntro =
  'برای پیگیری نوبت، سوالات و درخواست‌های خود می‌توانید از راه‌های زیر با پذیرش۲۴ در ارتباط باشید.';

export const officeAddress = {
  label: 'آدرس دفتر یزد',
  value: 'یزد، میدان آزادی، خیابان شهید مطهری، پارک علم و فناوری اقبال',
};

export const postalCode = {
  label: 'کدپستی',
  value: '8917697998',
};

export const workingHours = {
  label: 'ساعت کاری',
  value: '۸ الی ۱۵:۳۰',
};

export const contactEmail = {
  label: 'ایمیل',
  value: 'info@paziresh24.com',
  href: 'mailto:info@paziresh24.com',
};

export const contactPhone = {
  label: 'صندوق صوتی',
  value: '۰۲۱۲۵۰۱۵۰۱۵',
  href: 'tel:+982125015015',
};
